import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ImageLoader from 'react-render-image';
import { fg } from '@atlaskit/platform-feature-flags';
import { LoadingSkeletonNew, LoadingSkeletonOld } from '../loading-skeleton';
var ImageIcon = function ImageIcon(_ref) {
  var defaultIcon = _ref.defaultIcon,
    testId = _ref.testId,
    url = _ref.url,
    width = _ref.width,
    height = _ref.height,
    onError = _ref.onError,
    onLoad = _ref.onLoad;
  return /*#__PURE__*/React.createElement(ImageLoader, _extends({
    src: url
  }, fg('platform-smart-card-icon-migration') ? {
    loading: /*#__PURE__*/React.createElement(LoadingSkeletonNew, {
      testId: "".concat(testId, "-loading"),
      width: width,
      height: height
    }),
    loaded: /*#__PURE__*/React.createElement("img", {
      src: url,
      "data-testid": "".concat(testId, "-image"),
      alt: "",
      style: {
        width: width,
        height: height
      }
    })
  } : {
    loading: /*#__PURE__*/React.createElement(LoadingSkeletonOld, {
      testId: "".concat(testId, "-loading")
    }),
    loaded: /*#__PURE__*/React.createElement("img", {
      src: url,
      "data-testid": "".concat(testId, "-image"),
      alt: ""
    })
  }, {
    errored: defaultIcon,
    onError: onError,
    onLoad: onLoad
  }));
};
export default ImageIcon;